import { Polkadot, Kusama, InterBtc, KBtc, InterBtcAmount, KBtcAmount, Kintsugi, Interlay, VoteInterlay, VoteKintsugi, } from "@interlay/monetary-js";
import { newMonetaryAmount } from "../utils";
export var CurrencyIdLiteral;
(function (CurrencyIdLiteral) {
    CurrencyIdLiteral["DOT"] = "DOT";
    CurrencyIdLiteral["INTERBTC"] = "IBTC";
    CurrencyIdLiteral["INTR"] = "INTR";
    CurrencyIdLiteral["KSM"] = "KSM";
    CurrencyIdLiteral["KBTC"] = "KBTC";
    CurrencyIdLiteral["KINT"] = "KINT";
})(CurrencyIdLiteral || (CurrencyIdLiteral = {}));
const CollateralCurrency = [Polkadot, Kusama, Interlay, Kintsugi];
export const WrappedCurrency = [InterBtc, KBtc];
export const WrappedAmount = [InterBtcAmount, KBtcAmount];
export const GovernanceCurrency = [Interlay, Kintsugi];
export const VotingCurrency = [VoteInterlay, VoteKintsugi];
export class ChainBalance {
    constructor(currency, free, transferable, reserved) {
        this.currency = currency;
        this.free = newMonetaryAmount(free || 0, currency);
        this.transferable = newMonetaryAmount(transferable || 0, currency);
        this.reserved = newMonetaryAmount(reserved || 0, currency);
    }
    /*
        First stringifies the `MonetaryAmount`s, then the entire object.
        Allows for simple comparison in tests.
    */
    toString() {
        const stringifiedChainBalance = Object.fromEntries(Object.entries(this).map(([k, v]) => [k, v.toString()]));
        return JSON.stringify(stringifiedChainBalance);
    }
}
export function parseOrmlTokensAccountData(data, currency) {
    return new ChainBalance(currency, data.free.toString(), data.free.sub(data.frozen).toString(), data.reserved.toString());
}
export function parseEscrowLockedBalance(governanceCurrency, escrowLockedBalance) {
    return {
        amount: newMonetaryAmount(escrowLockedBalance.amount.toString(), governanceCurrency),
        endBlock: escrowLockedBalance.end.toNumber(),
    };
}
//# sourceMappingURL=currency.js.map